import {Translate} from "../../../../../../hooks/translate.hook";
import {ColumnsType} from "antd/es/table";
import {PriceList} from "../../../../../../models/price-lists/price.lists";
import {Amount} from "../../../../../../models/prices/price";
import {displayPrice} from "../../../../../../models/prices/price.helper";
import {Button, Space} from "antd";
import {Price} from "../../../../../../models/articles/articles.prices";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const columnsFactory = (
    t: Translate,
    displayHistory: (price: Price) => void,
    changePrice: (price: Price) => void
): ColumnsType<Price> => {
    return [
        {
            title: t("NAME"),
            dataIndex: "price",
            key: "price",
            render: (price: PriceList) => <>{price.name}</>,
            width: '60%'
        },
        {
            title: t("PRICE"),
            dataIndex: "amount",
            key: "amount",
            render: (item: Amount) => <>{displayPrice(item)}</>
        },
        {
            title: t("PRICES.MINIMAL_PRICE"),
            dataIndex: "minimalAmount",
            key: "minimalAmount",
            render: (item: Amount) => <>{displayPrice(item)}</>
        },
        {
            title: '',
            dataIndex: "actions",
            key: "actions",
            render: (_: any, item) => <Space direction={"horizontal"} style={{flexDirection: "row-reverse"}}>
                <Button
                    onClick={() => displayHistory(item)}
                    icon={<FontAwesomeIcon icon={["fas", "history"]} />}
                    type={"text"}
                />
                <Button
                    onClick={() => changePrice(item)}
                    icon={<FontAwesomeIcon icon={["fas", "edit"]} />}
                    type={"text"}
                />
            </Space>
        }
    ];
}